import config from "config/config";
import { Icon } from "components/icon/Icon";
import { useRootStore } from "store";

import "./Footer.scss";


export default function Footer() {
  const {staticInformation} = useRootStore((state)=> state.global)
  const office = staticInformation.headOfficeAddressInformation;

  return (
    <footer className="footer no-print">
      <div className="footer-inner">
        <section>
          <div className="footer-section-header">Huvudkontor</div>
          <address>
            <div>{office.title}</div>
            <div>{office.streetAddress}</div>
            <div>
              {office.zipcode} {office.city}
            </div>
          </address>
        </section>

        <section>
          <div className="footer-section-header">Kontakt</div>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://ludvig.se/kontakta-oss"
          >
            Kontakta oss
          </a>
        </section>

        <section>
          <div className="footer-section-header">Hjälp</div>
          <div>
            <a
              href={config.static.licenseAgreement}
              rel="noreferrer"
              target="_blank"
            >
              Användarvillkor
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://kundsupport.ludvig.se/support/home"
            >
              Support
            </a>
          </div>
        </section>

        <section>
          <div className="footer-section-header">Följ oss</div>

          <div className="d-inline-flex">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/ludvigco/"
            >
              <Icon
                className="circle-icon mr-3"
                name="fab fa-facebook-f circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/ludvigco"
            >
              <Icon
                className="circle-icon mr-3"
                name="fab fa-linkedin circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/ludvig.co/"
            >
              <Icon
                className="circle-icon mr-3"
                name="fab fa-instagram circle-icon"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/user/LRFKonsultMedia"
            >
              <Icon
                className="circle-icon mr-3"
                name="fab fa-youtube circle-icon"
              />
            </a>
          </div>
        </section>
      </div>
    </footer>
  );
}